import {onLoad} from "../base/onLoad";

const selector = ".image-card";

onLoad(() => {
    const cards = Array.from(document.querySelectorAll(selector));
    for (const card of cards) {
        const title = card.querySelector('.title') as HTMLElement;
        const innerContent = card.querySelector('.inner-content') as HTMLElement;
        if (!title || !innerContent) {
            continue;
        }

        const titleHeight = title.offsetHeight;
        const transform = `calc(100% - ${titleHeight}px - 30px)`;
        (card as HTMLElement).style.setProperty('--image-card-offset', transform);
    }
}, {
    checkForElements: [selector]
});